import { CheckoutCartMachineContext, StartCheckoutEvent } from './types';

export const isCheckoutCartIdMissing = (
  context: CheckoutCartMachineContext,
) => {
  return !context.checkoutCartId;
};

export const isCheckoutCartStale = (
  context: CheckoutCartMachineContext,
  event: StartCheckoutEvent,
) => {
  return context.checkoutCartId !== event.checkoutCartId;
};

export const isCheckoutCartIdMissingOrStale = (
  context: CheckoutCartMachineContext,
  event: StartCheckoutEvent,
) => {
  return (
    isCheckoutCartIdMissing(context) || isCheckoutCartStale(context, event)
  );
};

export const isCartMissing = (context: CheckoutCartMachineContext) => {
  return context.checkoutCartId != null && !context.checkoutCart;
};

export const isUserNotReady = (context: CheckoutCartMachineContext) => {
  return !context.isUserReady;
};

export const areProductsMissing = (context: CheckoutCartMachineContext) => {
  return !context.products;
};
